module.exports = __webpack_public_path__ + "static/media/error.6d44038e.svg";